import { FC, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "../src/router/router";
import { UserProvider } from "./pages/providers/userProvider";
import { ThemeProvider } from "@mui/material";
import { theme } from "./customization/customTheme";
import { ConfirmProvider } from "material-ui-confirm";

export const App: FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <ConfirmProvider>
        <UserProvider>
          <RouterProvider router={router} />
        </UserProvider>
      </ConfirmProvider>
    </ThemeProvider>
  );
};
